export type LabelItem = {
  code: number
  label: string
}

const BASE_LABEL_ITEMS: LabelItem[] = [
  { code: 1, label: 'メイン' },
  { code: 2, label: '勤務先' },
  { code: 3, label: '自宅' },
  { code: 4, label: '携帯' },
  { code: 8, label: '無線機番号' },
  // { code: 99, label: 'カスタム' },
  { code: 5, label: '勤務先FAX' },
  { code: 6, label: '自宅FAX' },
  { code: 7, label: 'その他' },
  { code: 9, label: '' }, // ''の際メインではなく 9 の 空
]

const isTelenet = () => {
  const env = process.env.REACT_APP_ENV
  // Telenet テナント（検証・商用とも）で code=8 を有効化する
  return env === 'TELENET_PROD' || env === 'TELENET_CVD'
}

/**
 * ✅ UIで表示してよいラベル一覧
 * - Telenet テナント（TELENET_PROD / TELENET_CVD）のときだけ code=8 を含める
 */
export const getUiLabelItems = (): LabelItem[] => {
  if (isTelenet()) return BASE_LABEL_ITEMS
  return BASE_LABEL_ITEMS.filter((x) => x.code !== 8)
}

/**
 * ✅ code -> label text (詳細表示/編集で共通化)
 */
export const getLabelText = (
  labelCode: number | null | undefined,
  customLabel?: string,
) => {
  if (labelCode === 99) return customLabel ?? ''
  if (labelCode === 9) return ''
  return BASE_LABEL_ITEMS.find((i) => i.code === labelCode)?.label ?? ''
}
